import React from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { ExpandableCard, Row, Stack, Text, Select } from 'library/ui';
import ZipSearch from './ZipSearch';
import {
    FilterOption,
    StaffFilterOptions,
    educationOptions,
    experienceOptions,
} from 'parent-portal/shared/filterOptions';

function FilterDropdownSection({
    label,
    value,
    options,
    onChange,
}: {
    label: string;
    value: string;
    options: FilterOption[];
    onChange: (value: string) => void;
}) {
    return (
        <Stack gap="sm">
            <Text size="xs" weight="bold" uppercase>
                {label}
            </Text>
            <Select value={value} options={options} onChange={onChange} fullWidth />
        </Stack>
    );
}

export default function PublicFilters({
    zipCode,
    updateZipCode,
    filters,
    onSearch,
}: {
    zipCode: string;
    updateZipCode: (value: string) => void;
    filters: StaffFilterOptions;
    onSearch: (filters: StaffFilterOptions) => void;
}) {
    function updateFilter(key: keyof StaffFilterOptions, value: string) {
        onSearch({ ...filters, [key]: value ? JSON.parse(value) : {} });
    }

    const title = (
        <Row align="center" gap="sm">
            <FilterListIcon style={{ color: Colors.primary, fontSize: 20 }} />
            <Text weight="bold">Filters</Text>
        </Row>
    );

    return (
        <FilterContainer gap="md">
            <ZipSearch zipCode={zipCode} updateZipCode={updateZipCode} search={onSearch} />
            <ExpandableCard header={title} defaultExpanded>
                <Stack gap="md">
                    <FilterDropdownSection
                        label="Education"
                        value={JSON.stringify(filters.education)}
                        options={educationOptions}
                        onChange={(value) => updateFilter('education', value)}
                    />
                    <FilterDropdownSection
                        label="Experience"
                        value={JSON.stringify(filters.experience)}
                        options={experienceOptions}
                        onChange={(value) => updateFilter('experience', value)}
                    />
                </Stack>
            </ExpandableCard>
        </FilterContainer>
    );
}

const FilterContainer = styled(Stack)({
    width: 260,
    flexShrink: 0,
    height: 'fit-content',
});
